var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navContainer" }, [
    _c("nav", { staticClass: "container clearfix" }, [
      _c(
        "div",
        { staticClass: "fl" },
        [
          _c(
            "router-link",
            { staticStyle: { display: "inline-block" }, attrs: { to: "/" } },
            [
              _c("img", {
                attrs: { src: _vm.url + _vm.infoData.siteLogo, alt: "logo" }
              })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fr" },
        [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.key == "/login"
                  ? "未注册交易所账号，点击"
                  : "已有交易所账号，点击"
              )
            )
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            { attrs: { to: _vm.key == "/login" ? "/register" : "/login" } },
            [_vm._v(_vm._s(_vm.key == "/login" ? "注册" : "登录"))]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ef2e8c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef2e8c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/components/PublicNav.vue
// module id = null
// module chunks = 